// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"93dc160b","977":"b65e1594"}[chunkId] + ".chunk.js";
};